import actionTypes from '../actionTypes';
import { fetch } from '../../api';
import constants from '../../constants.js';

export function composeMessage(thread, body, oldId, deleteIfFailed = false) {
  return async function (dispatch, getState) {
    const state = getState();

    if (!thread) return null;
    if (!thread.id) {
      return dispatch(composeMessage(state.data.threads[thread], body, oldId));
    }

    const message = {
      author: state.context.userId,
      body,
      id: oldId || `${constants.TEMPORARY_PREFIX}${Date.now()}`,
      isTemporary: true,
      hasFailed: false,
      thread: thread.id,
      dateCreated: new Date().toJSON(),
    };

    dispatch({
      type: actionTypes.MESSAGE_SEND,
      data: { messages: [message], threads: [thread] },
    });
    const bodyQuery = {
      body,
      participantIds: thread.isTemporary ? thread.participants
        .map(user => user.id)
        .filter(id => id !== state.context.userId) : undefined,
      subject: thread.subject,
    };
    if (!thread.isTemporary) {
      bodyQuery.threadId = thread.id;
    }

    try {
      const { payload } = await fetch(
        'message/send',
        { method: 'POST', body: JSON.stringify(bodyQuery) }
      );

      const update = {
        isTemporary: false,
        hasFailed: false,
        lastActiveUser: message.author,
        body: message.body,
      };

      return dispatch({
        type: actionTypes.MESSAGE_SEND_SUCCESS,
        isAsynchronous: true,
        data: {
          messages: [{ ...message, id: payload.id, thread: payload.threadId, ...update }],
          threads: [{ ...thread, id: payload.threadId, ...update }],
        },
        dataToDelete: {
          messages: [message],
          threads: [thread].filter(({ isTemporary }) => isTemporary),
        },
      });
    } catch (error) {
      const data = deleteIfFailed ? {} : { messages: [{ id: message.id, hasFailed: true }] };
      const dataToDelete = deleteIfFailed ? { messages: [message] } : {};

      return dispatch({
        type: actionTypes.MESSAGE_SEND_FAILURE,
        isAsynchronous: true,
        data,
        dataToDelete,
        error,
        alert: {
          type: actionTypes.MESSAGE_SEND_FAILURE,
          alertType: 'warning',
          threadId: thread.id,
          message: body,
          oldId,
        },
      });
    }
  };
}



// WEBPACK FOOTER //
// ./~/virgo/src/actions/dataActionsCreator/messageActionsCreator.js